import { createContext } from "react";
import type { CoachesContextType } from "./CoachesContext.types";

const CoachesContext = createContext<CoachesContextType | undefined>(undefined);
CoachesContext.displayName = "CoachesContext";

export default CoachesContext;
